<div class="mt-1">
  <label></label>
</div>
<form [formGroup]="personForm">
  <div class="row mt-2">
    <div class="col-md-8 offset-md-2">
      <div class="row col mb-2">
        <h4 class="title">{{"TITLE.PASSWORD-UPDATE" | translate}}</h4>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <h5>{{ "TITLE.UPGRADE-REQUIREMENTS" | translate }}</h5>
          {{ "MESSAGE.YOU-MUST-ENTER-PASSWORD-THAT-CONTAINS-UPPERCASE-LOWER-NUMBERS-AND-AT-LEST-ONE-SPECIAL-CHARACTER" | translate }}
          .
        </div>
        <div class="col-md-6">
          <div class="form-row">
            <div class="form-group col">
              <label for="newPasswordInput">{{ "LABEL.PASSWORD" | translate }}</label>
              <div class="input-group">
                <input [type]="fieldTextTypeNew ? 'text' : 'password'"
                       class="form-control"
                       id="newPasswordInput"
                       placeholder="{{ 'MESSAGE.ENTER-NEW-PASSWORD' | translate }}"
                       formControlName="newPassword"
                       [class.is-invalid]="isInvalidControl('newPassword')"
                       (keyup)="validatePassword()">
                <div class="input-group-append">
                <span class="input-group-text">
                 <i
                   class="fa {{fieldTextTypeNew?'fa-eye':'fa-eye-slash'}}"
                   (click)="toggleFieldTextType(NEW_PASSWORD)"
                 ></i>
              </span>
                </div>
              </div>
              <div>
                <small *ngIf="isInvalidControl('newPassword')"
                       class="text-danger">
                  {{getErrorMessageBy('newPassword') | translate}}
                </small>
              </div>
            </div>
          </div>
          <label *ngIf="isSecurityHigh">{{"LABEL.SECURITY-LEVEL" | translate}}:
            <b class="text-primary">{{"LABEL.HIGH" | translate}}</b></label>
          <label *ngIf="isSecurityMedium">{{"LABEL.SECURITY-LEVEL" | translate}}:
            <b class="text-success">{{"LABEL.MEDIUM" | translate}}</b></label>
          <label *ngIf="isSecurityLow">{{"LABEL.SECURITY-LEVEL" | translate}}:
            <b class="text-secondary">{{"LABEL.LOW" | translate}}</b></label>
          <ul class="mt-2">
            <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                *ngIf="isSecurityHigh">
              <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.MINIMUM-LENGTH-12" | translate}}
            </li>
            <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                *ngIf="isSecurityMedium">
              <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.MINIMUM-LENGTH-8" | translate}}
            </li>
            <li class="{{passwordControls?.isValidLength ? 'text-success':'text-danger'}}"
                *ngIf="isSecurityLow">
              <i class="{{passwordControls?.isValidLength ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.MINIMUM-LENGTH-6" | translate}}
            </li>
            <li class="{{passwordControls?.hasUpperCase ? 'text-success':'text-danger'}}"
                *ngIf="!isSecurityLow">
              <i class="{{passwordControls?.hasUpperCase ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.CONTAINS-CAPITAL-LETTER" | translate}}
            </li>
            <li class="{{passwordControls?.hasLowerCase ? 'text-success':'text-danger'}}"
                *ngIf="!isSecurityLow">
              <i class="{{passwordControls?.hasLowerCase ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.CONTAINS-LOWERCASE-LETTER" | translate}}
            </li>
            <li class="{{passwordControls?.hasNumber ? 'text-success':'text-danger'}}"
                *ngIf="!isSecurityLow">
              <i class="{{passwordControls?.hasNumber ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.CONTAINS-A-NUMBER" | translate}}
            </li>
            <li class="{{passwordControls?.hasSpecialChar ? 'text-success':'text-danger'}}"
                *ngIf="!isSecurityLow && !isSecurityMedium">
              <i class="{{passwordControls?.hasSpecialChar ? 'fas fa-check': 'fas fa-times'}}"></i>
              {{"MESSAGE.CONTAINS-SPECIAL-CHARACTER" | translate}}
            </li>
          </ul>
          <small
            *ngIf="personForm.get('newPassword').errors?.passwordComplexity && personForm.get('newPassword').touched"
            class="text-danger">
            {{"MESSAGE.PASSWORD-REQUIRED-MUST-MEET-REQUIREMENTS" | translate}}
          </small>
          <div class="form-row">
            <div class="form-group col">
              <label for="repeatNewPasswordInput">{{ "LABEL.REPEAT-PASSWORD" | translate }}</label>
              <div class="input-group">
                <input [type]="fieldTextTypeNewRepeat ? 'text' : 'password'"
                       class="form-control"
                       id="repeatNewPasswordInput"
                       placeholder="{{ 'MESSAGE.RE-ENTER-NEW-PASSWORD' | translate }}"
                       formControlName="repeatNewPassword"
                       [class.is-invalid]="isInvalidControl('repeatNewPassword')"
                       (keyup)="validatePassword()">
                <div class="input-group-append">
                <span class="input-group-text">
                 <i
                   class="fa {{fieldTextTypeNewRepeat?'fa-eye':'fa-eye-slash'}}"
                   (click)="toggleFieldTextType(NEW_REPEAT_PASSWORD)"
                 ></i>
              </span>
                </div>
              </div>
              <div>
                <small *ngIf="isInvalidControl('repeatNewPassword')"
                       class="text-danger">
                  {{getErrorMessageBy('repeatNewPassword')}}
                </small>
              </div>
              <small *ngIf="!areSamePasswords"
                     class="text-danger">
                <br *ngIf="isInvalidControl('repeatNewPassword')">
                {{ "MESSAGE.PASSWORDS-DO-NO-MATCH" | translate }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer custom-padding">
        <button type="button" class="btn btn-outline-success" (click)="save()">
          <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}</button>
        <button type="button" class="btn btn-outline-danger" (click)="cancel()">
          <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}</button>
      </div>
    </div>
  </div>
</form>
<app-loading *ngIf="loading"></app-loading>
